import { ReactNode } from 'react';
import { Button } from '@sweep-io/sweep-design';
import usePermission from '../permissions/usePermission';
import { Permission } from '@server/permissions';
import RestrictedTooltip from '../permissions/RestrictedTooltip';
import EmptyState from './EmptyState';
import { ButtonSize } from '@sweep-io/sweep-design/dist/components/Button/types';

const EmptyStateWithButton = ({
  image,
  line1,
  line2,
  titleLine,
  onClick,
  permissionString,
  notAllowedTitle,
  buttonDisabled,
  buttonSize = 'large',
}: {
  image: ReactNode;
  titleLine?: string;
  line1?: string;
  line2?: string;
  onClick: () => void;
  permissionString: Permission[];
  notAllowedTitle: string;
  buttonDisabled?: boolean;
  buttonSize?: ButtonSize;
}) => {
  const [isAllowedBtn] = usePermission(permissionString);

  return (
    <EmptyState image={image} line1={line1} line2={line2} titleLine={titleLine}>
      <RestrictedTooltip to={permissionString} notAllowedTitle={notAllowedTitle}>
        <Button onClick={onClick} disabled={!isAllowedBtn || buttonDisabled} size={buttonSize}>
          Get started
        </Button>
      </RestrictedTooltip>
    </EmptyState>
  );
};

export default EmptyStateWithButton;
